import React from 'react'
import { Badge } from 'antd'
import styles from './BadgeIcon.module.css';

type Props = {
  label: string;
  color: string;
  bgColor: string;
}

const BadgeIcon = (props: Props) => {

  const {label, color, bgColor} = props;
  
  return (
    <>
    <Badge className={styles.badgeicon} style={{backgroundColor: bgColor, color: color}} overflowCount={5000} count={label} ></Badge>
    </>
  )
}

export default BadgeIcon